import { Form, Formik } from "formik";
import FormikControl from "../../../../../Formik/FormikControl";
import * as Yup from "yup";
import ILobbyGame from "../../../../../Interfaces/LobbyGame";
import ITournament from "../../../../../Interfaces/Tournament";
import GAMES from "../../../../../../constants-games";

type Props = {
  tournament: ITournament;
  initialValues: ILobbyGame | undefined;
  loading: boolean;
  title: string;
  onAddGame: (data: any) => void;
  onRemoveGame: (event: any, gameNumber: number) => void;
};

const initValidationSchema = Yup.object({
  gameNumber: Yup.number(),
  player_password: Yup.string(),
  start_game: Yup.date().required().nullable(),
  end_game: Yup.date().required().nullable(),
  room_id: Yup.string(),
  room_name: Yup.string(),
});

const CreateEditLobbyGameModal = (props: Props) => {
  const { tournament, initialValues, title, loading } = props;

  const gameMapSchemaObject = Yup.object({
    map_name: Yup.string().required("Required!"),
  });
  
  const validationSchema =
    GAMES[tournament?.game!].MAPS
      ? initValidationSchema.concat(gameMapSchemaObject)
      : initValidationSchema;

  return (
    <div className="container">
      <div className="columns">
        <div className="column col-12">
          {initialValues && (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={props.onAddGame}
              enableReinitialize={true}
            >
              {({ errors, touched, isValid, setFieldValue }) => (
                <Form>
                  <FormikControl
                    control="date"
                    label="Start Game Date and Time"
                    name="start_game" 
                    dateFormat="dd/MM/yyyy h:mm aa"
                    showTimeSelect
                  />
                  <FormikControl
                    control="date"
                    label="End Game Date and Time"
                    name="end_game" 
                    dateFormat="dd/MM/yyyy h:mm aa"
                    showTimeSelect
                  />
                  <FormikControl
                    control="input"
                    label="Player Password"
                    name="player_password"
                  />
                  <FormikControl
                    control="input"
                    label="Room ID"
                    name="room_id"
                  />
                  <FormikControl
                    control="input"
                    label="Room Name"
                    name="room_name"
                    />
                  {GAMES[tournament?.game!].MAPS && (
                    <FormikControl
                      control="select"
                      label="Game Map"
                      name="map_name"
                      options={GAMES[tournament?.game!].MAPS}
                    />
                  )}
                  <div className="space-divider-20"></div>
                  <button
                    className="skp-btn skp-btn-primary float-right"
                    type="submit"
                    disabled={!isValid || loading}
                  >
                    Save Game
                  </button>
                </Form>
              )}
            </Formik>
          )}
          {initialValues?.gameNumber && title === "Edit Game" && (
            <button
              disabled={loading}
              className="skp-btn skp-btn-alert"
              onClick={(e) => props.onRemoveGame(e, initialValues.gameNumber)}
            >
              <i className="las la-trash"></i> Delete game
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateEditLobbyGameModal;
